jQuery(document).ready(function ($) {
    /** Toggle product categories drop-down */
    $(".sidebar ul.product-categories .expand").click(function() {
        $(this).parent().toggleClass('open');
        $(this).parent().find(".children").slideToggle();
        if ($(this).parent().hasClass('open')){
            $(this).text("-");
        } else {
            $(this).text("+");
        }
    });
});